var OCS = OCS || {};
OCS.Data = OCS.Data || {};
OCS.Data.Geometry = OCS.Data.Geometry || {};
OCS.Geometry = OCS.Geometry || {};
OCS.Geometry.sid_to_table_and_id = OCS.Geometry.sid_to_table_and_id || {};
OCS.Geometry.Settings = OCS.Geometry.Settings || {};
OCS.Geometry.Functions = OCS.Geometry.Functions || {};
OCS.Geometry.Functions.AddGeometry = function(feature) {
    var table = feature.options.properties.table;
    var table_id = feature.options.properties.table_id;
    var sid = feature.options.properties.sid;
    var prop_key = OCS.Geometry.Functions.getPropKey(feature.get_crs_name(), feature.options.properties.simplified);
    if(!table && !table_id) {
        table = 'unk';
        table_id = sid;
    }
    if(!OCS.Data.Geometry[table]) {
        OCS.Data.Geometry[table] = {};
    }
    if(!OCS.Data.Geometry[table][table_id]) {
        OCS.Data.Geometry[table][table_id] = {};
    }
    if(sid) {
        if(OCS.Geometry.sid_to_table_and_id[sid] && OCS.Geometry.sid_to_table_and_id[sid].table === 'unk' && table !== 'unk') {
            // Rework all the unknowns to there respective known entries
            Object.keys(OCS.Data.Geometry.unk[sid]).each(function(old_prop) {
                if(old_prop !== prop_key) {
                    OCS.Data.Geometry[table][table_id][old_prop] = OCS.Data.Geometry.unk[sid][old_prop];
                    delete OCS.Data.Geometry.unk[sid][old_prop];
                }
            });
            delete OCS.Data.Geometry.unk[sid];
        }
        OCS.Geometry.sid_to_table_and_id[sid] = {table: table, table_id: table_id};
    }

    if(OCS.Data.Geometry[table][table_id][prop_key]) {
        var old_feature = OCS.Data.Geometry[table][table_id][prop_key];
        if(!old_feature.get_sid() && sid) {
            old_feature.set_sid(sid);
        }
        return old_feature;
    }
    OCS.Data.Geometry[table][table_id][prop_key] = feature;
    return feature;

};
OCS.Geometry.Functions.MakeGeometriesRequest = function(req_data, request_success, url, request_method) {
    if(!req_data || (!req_data.ids && !req_data.id)) {
        return false;
    }
    if(!url) {
        url = OCS.Geometry.Functions.getURL('geometries');
    }
    var req = OCS.Functions.get_ajax_manager().request(url + JSON.stringify(req_data.ids), OCS.Geometry.Functions.getDefaultRequestProp({"url": url, "request_success_method": request_success, "method": request_method}), true);
    req.req_ids = req_data.ids;
    req.send({data: req_data});
    return req;
};
OCS.Geometry.Functions.MakeLocateRequest = function(req_data, request_success, url, request_method) {
    if(!req_data || !req_data.x || !req_data.y) {
        return false;
    }
    if(!url) {
        url = OCS.Geometry.Functions.getURL('locate');
    }
    var req = OCS.Functions.get_ajax_manager().request(url + JSON.stringify(req_data), OCS.Geometry.Functions.getDefaultRequestProp({"url": url, "request_success_method": request_success, "method": request_method}), true);
    req.send({data: req_data});
    return req;
};
OCS.Geometry.Functions.MakeTableRequest = function(req_data, request_success, url, request_method) {
    if(!req_data || !url) {
        return false;
    }
    var req = OCS.Functions.get_ajax_manager().request(url + JSON.stringify(req_data), OCS.Geometry.Functions.getDefaultRequestProp({"url": url, "request_success_method": request_success, "method": request_method}), true);
    req.send({data: req_data});
    return req;
};

OCS.Geometry.Functions.getDefaultRequestProp = function(ops) {
    var req_settings = {'dataType': 'json', 'responseType': 'json'};
    if(!ops) {
        req_settings.method = "GET";
        return req_settings;
    }
    if(!ops.request_method) {
        req_settings.method = "GET"; // Default to GET
    }
    if(ops.url) {
        req_settings.url = ops.url;
    }
    if(ops.request_success_method) {
        req_settings.onSuccess = ops.request_success_method;
    }
    if(ops.request_failure_method) {
        req_settings.onFailure = ops.request_failure_method;
    }
    var cache = OCS.Geometry.Functions.getGeometryCached();
    if(cache) {
        req_settings.cache = true;
    } else {
        req_settings.cache = false;
        req_settings.noCache = true;
    }
    return req_settings;
};
OCS.Geometry.Functions.getKey = function(id, crs_name, simplification) {
    if(id && !crs_name && !simplification && id.id) {
        if(id.projection) {
            crs_name = id.projection;
        }
        if(id.simplify) {
            simplification = id.simplify;
        }
        id = id.id;
    }
    if(!id) {
        return false;
    }
    return id+"-"+OCS.Geometry.Functions.getPropKey(crs_name, simplification);
};
OCS.Geometry.Functions.getPropKey = function(crs_name, simplification) {
    if(!crs_name) {
        crs_name = 'std';
    } else {
        crs_name = OCS.Geometry.Functions.getShortCrsProjectionName(crs_name);
    }
    if(simplification || simplification === 0) {
        return crs_name + "-"+simplification;
    } else {
        return crs_name;
    }
};
/**
 * Returns the requested geometry with the specified properties, false if none is found. If no simplification is specified will return a geometry of any simplification if fouind
 *
 * @param table
 * @param table_id
 * @param crs_name
 * @param simplification
 * @returns {*}
 */
OCS.Geometry.Functions.getGeometry = function(table, table_id, crs_name, simplification) {
    if(OCS.Data.Geometry[table] && OCS.Data.Geometry[table][table_id]) {
        var geometries = OCS.Data.Geometry[table][table_id];
        var prop_key = OCS.Geometry.Functions.getPropKey(crs_name, simplification);
        if(geometries[prop_key]) {
            return geometries[prop_key];
        } else {
            if(simplification !== 0) {
                var geom_keys = Object.keys(geometries);
                var i = 0;
                for(i; i < geom_keys.length; i++) {
                    if(geom_keys[i].contains(prop_key)) {
                        return geometries[geom_keys[i]];
                    }
                }
            }

        }
    }
    return false;
};
OCS.Geometry.Functions.getGeometryBySid = function(id, crs_name, simplification) {
    var table_prop = OCS.Geometry.Functions.getTableAndId(id);
    if(table_prop) {
        return OCS.Geometry.Functions.getGeometry(table_prop.table, table_prop.table_id, crs_name, simplification);
    } else {

    }

};
OCS.Geometry.Functions.getGeometryCached = function() {
    if(OCS.Geometry.Settings.cache || OCS.Geometry.Settings.cache === false) {
        return OCS.Geometry.Settings.cache;
    } else {
        return true;
    }
};
OCS.Geometry.Functions.getGeometryHost = function() {
    if(OCS.Geometry.Settings.host) {
        return OCS.Geometry.Settings.host;
    } else {
        return false;
    }
};
OCS.Geometry.Functions.getGeometryVersion = function() {
    if(OCS.Geometry.Settings.version) {
        return OCS.Geometry.Settings.version;
    } else {
        return 'v1';
    }
};
OCS.Geometry.Functions.getURL = function(method) {
    var host = OCS.Geometry.Functions.getGeometryHost();
    var version = OCS.Geometry.Functions.getGeometryVersion();
    var url = false;
    if(host && version) {
        url = host+"/api/"+version+"/";
        if(method) {
            url += method;
        }
    }
    return url;

};
OCS.Geometry.Functions.getTableAndId = function(sid) {
    if(OCS.Geometry.sid_to_table_and_id[sid]) {
        return OCS.Geometry.sid_to_table_and_id[sid];
    } else {
        return false;
    }
};





